// Stessa semantica per barra principale, sottofasi, legenda e badge.
export const GANTT_COLORS = {
  studio: ["#cbdced", "#367dc4"],
  waiting: ["#e1e5e8", "#8d9aa6"],
  done: ["#c9dfd2", "#20b978"],
  settled: ["#c9dfd2", "#20b978"],
  late: ["#f4d1ca", "#e66c5e"],
  soon: ["#f3e3bc", "#daa031"],
  planned: ["#eff2f5", "#c0cbd5"],
};

export function summaryState(row) {
  if (row.has_overdue_studio) return "late";
  if (row.phases.some(phase => phase.state === "soon")) return "soon";
  if (row.has_studio_actions) return "studio";
  if (row.has_external_waits) return "waiting";
  if (row.economics?.stage === "saldata") return "settled";
  if (row.closed) return "done";
  if (row.owner === "esterno") return "waiting";
  if (row.phases.some(phase => phase.state === "late")) return "late";
  if (row.phases.some(phase => phase.state === "soon")) return "soon";
  if (row.phases.length && row.phases.every(phase => phase.done)) return "done";
  return "studio";
}

export const barGradient = state => {
  const [start, end] = GANTT_COLORS[state] || GANTT_COLORS.planned;
  return { "--gantt-bar-start": start, "--gantt-bar-end": end };
};